import { ArrowLeftIcon, ArrowRightIcon } from '@radix-ui/react-icons';
import { addDays } from 'date-fns';
import * as React from 'react';
import Button from 'src/components/molecules/Button';
import cn from 'src/lib/cn';
import { formatMonthWeek, formatWeekday, today } from 'src/lib/date';
import { useCalendarPageContext } from '../../CalendarPageContext';
import WeekDay from './WeekDay';

interface IProps {
  activeDate: Date;
  onDateSelect?: (date: Date) => void;
}

const WeekScroller: React.FC<IProps> = ({ activeDate, onDateSelect }) => {
  const { weeks, bookings } = useCalendarPageContext();

  const week = weeks.find(w => w.some(d => d.getTime() === activeDate.getTime()))?.slice(0, 5) ?? [];

  return (
    <div className="calendar calendar--week-scroller">
      <div className="calendar__title">
        <Button onClick={() => onDateSelect && onDateSelect(addDays(activeDate, -7))}>
          <ArrowLeftIcon />
        </Button>
        <div className="panel-title-text">{formatMonthWeek(activeDate)}</div>
        <div></div>
        <Button onClick={() => onDateSelect && onDateSelect(addDays(activeDate, 7))}>
          <ArrowRightIcon />
        </Button>
        <Button onClick={() => onDateSelect && onDateSelect(today())}>Today</Button>
      </div>
      <div className={cn('calendar__grid calendar__grid--5cols')}>
        {week.map((date, index) => (
          <div key={index} className="calendar__grid-header">
            {formatWeekday(date)}
          </div>
        ))}
        {week.map(date => (
          <WeekDay
            key={date.toISOString()}
            date={date}
            disabled={date.getMonth() !== activeDate.getMonth()}
            active={date.getTime() === activeDate.getTime()}
            onClick={() => onDateSelect?.(date)}
            bookings={bookings?.[date.toISOString()]}
          />
        ))}
      </div>
    </div>
  );
};

export default WeekScroller;
